import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import api from '../config/api';

const AdminPrivateRoute = ({ children }) => {
  const { isAuthenticated, admin, logout, loading } = useAdminAuth();
  const [verifying, setVerifying] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Only verify token when accessing protected routes and initial load is complete
    const token = localStorage.getItem('admin_token');
    if (!loading && token && admin && !verifying) {
      setVerifying(true);
      // Quick verification with timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout')), 2000)
      );
      
      Promise.race([
        api.get('/admin/profile'),
        timeoutPromise
      ])
        .then((response) => {
          if (!response.data.success) {
            logout();
          }
        })
        .catch(() => {
          // If verification fails, logout
          logout();
        })
        .finally(() => {
          setVerifying(false);
        });
    } else if (!token) {
      // No token, don't verify
      setVerifying(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, loading]);

  // Show loading during initial restoration or verification
  if (loading || verifying) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

export default AdminPrivateRoute;

